export const MatomoActions = {
  search: 'trackSiteSearch',
  event: 'trackEvent',
  contentInteraction: 'trackContentInteractionNode',
  setDocumentTitle: 'setDocumentTitle',
  setCustomUrl: 'setCustomUrl',
  setEcommerceView: 'setEcommerceView',
  trackPageView: 'trackPageView',
  addEcommerceItem: 'addEcommerceItem',
  trackEcommerceCartUpdate: 'trackEcommerceCartUpdate',
  trackEcommerceOrder: 'trackEcommerceOrder',
  setUserId: 'setUserId',
  enableLinkTracking: 'enableLinkTracking',
  trackVisibleContentImpressions: 'trackVisibleContentImpressions',
  setTrackerUrl: 'setTrackerUrl',
  setSiteId: 'setSiteId',
  optOut: 'optUserOut',
  forgetOptOut: 'forgetUserOptOut'
};
